import { Badge, Box, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHand,
  faInfoCircle,
  faWarning
} from '@fortawesome/pro-solid-svg-icons';
import { IReviewerCOIItem } from '@publishing-engine/domain/views';

interface Props {
  errors: IReviewerCOIItem[];
  warnings: IReviewerCOIItem[];
  info: IReviewerCOIItem[];
}

const ReviewerConflictInfo = ({ errors, warnings, info }: Props) => {
  return (
    <>
      {errors?.length > 0 &&
        errors.map(error => {
          return (
            <Box>
              {' '}
              <Badge
                variant="caution"
                marginBottom={2}
                whiteSpace="normal"
                wordBreak="break-word"
                display="block"
                width={'max-content'}
              >
                <Flex alignItems="flex-start" gap={1}>
                  <Text>
                    <FontAwesomeIcon icon={faWarning} />
                  </Text>
                  <Text>{`Conflict(s): ${error.message}`}</Text>
                </Flex>
              </Badge>
            </Box>
          );
        })}

      {warnings?.length > 0 &&
        warnings.map(warn => {
          return (
            <Box>
              {' '}
              <Badge
                variant="attention"
                marginBottom={2}
                whiteSpace="normal"
                wordBreak="break-word"
                display="block"
                width={'max-content'}
              >
                <Flex alignItems="flex-start" gap={1}>
                  <Text>
                    <FontAwesomeIcon icon={faHand} />
                  </Text>
                  <Text>{`Warning(s): ${warn.message}`}</Text>
                </Flex>{' '}
              </Badge>
            </Box>
          );
        })}

      {info?.length > 0 &&
        info.map(infoitem => {
          return (
            <Box>
              <Badge
                variant="neutral"
                marginBottom={1}
                whiteSpace="normal"
                wordBreak="break-word"
                width={'max-content'}
              >
                <Flex alignItems="flex-start" gap={1}>
                  <Text>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Text>
                  <Text>{`Info: ${infoitem.message}`}</Text>
                </Flex>{' '}
              </Badge>
            </Box>
          );
        })}
    </>
  );
};

export default ReviewerConflictInfo;
